export default __webpack_public_path__ + "images/react/components/trial-signup/assets/signup-page1-cb-retention.png";